import axiosInstance from "Api";

const PLANSCREEN_ENDPOINT = 'planscreen';

const getDetails = (shiftId) => {
    return axiosInstance.get(`${PLANSCREEN_ENDPOINT}/details/${shiftId}`);
}

const getSubstitutors = (shiftId, contractId) => {
    return axiosInstance.get(`${PLANSCREEN_ENDPOINT}/${shiftId}/${contractId}`)
}

const getAvailabilityBatch = (shiftId, contractId, adminIds) => {
    return axiosInstance.post(`${PLANSCREEN_ENDPOINT}/availability/${shiftId}/${contractId}`, {
        adminIds: adminIds
    });
}

const getFilters = (contractId, excludeWwz = '0', communityId = '0') => {
    return axiosInstance.get(`${PLANSCREEN_ENDPOINT}/filters/${contractId}`, {
        params: {
            excludeWwz: excludeWwz,
            communityId: communityId
        }
    })
}

const PlanscreenService = {
    getDetails,
    getSubstitutors,
    getAvailabilityBatch,
    getFilters
};
export default PlanscreenService;